module.exports = __webpack_public_path__ + "img/v4.5b274d6f.png";